<div class="container-fluid pt-4">
    <table class="table">
        <thead>
            <tr>
                <th>Date</th>
                <th>Item Type</th>
                <th>Item Id</th>
                <th>Item Content</th>
                <th>Author</th>
                <th>Moderation history</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>

            @for (timelineItem of moderationItems; track timelineItem){
            <tr>
                <td>{{timelineItem.date | date: 'dd-MM-yyyy'}}</td>
                <td>{{timelineItem.itemType}}</td>
                <td>
                    {{timelineItem.itemId}}
                    @if(timelineItem.parentId){
                    <br><strong>Parent:</strong> {{timelineItem.parentType}}: {{timelineItem.parentId}}
                    }
                </td>
                <td><strong class="text-dark">{{timelineItem.content}}</strong></td>
                <td>{{timelineItem.author.email.value}}</td>
                <td>
                    <table class="table table-light table-bordered table-sm">
                        <thead>
                            <tr>
                                <th>Status</th>
                                <th>Date</th>
                                <th>Reason</th>
                                <th>Reporter</th>
                                <th>Moderator</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (event of timelineItem.moderation.events; track event){
                            <tr>
                                <td>
                                @if (event['status']){
                                    <i class="far" [ngClass]="event.icon"></i>&nbsp;{{event['status'].description}}
                                }
                                </td>
                                <td>{{ event.timestamp | date: 'dd-MM-yyyy hh:mm' }}</td>
                                <td>
                                    <strong class="text-dark">{{event['reason']}}</strong>
                                </td>
                                <td>
                                @if (event['reporter']){
                                    <a href="mailto:{{event['reporter'].email.value}}?subject=TeamMood moderation request" target="_blank">{{event['reporter'].email.value}}</a>
                                }
                                </td>
                                <td>
                                @if (event['moderator']){
                                    {{event['moderator'].email.value}}
                                }
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </td>
                <td>
                    <div class="btn-group" role="group">
                        <a  [routerLink]="['/home', timelineItem.teamId]"
                            class="btn btn-default" 
                            target="_blank" 
                            [matTooltip]="'View team timeline'"><i class="fa fa-users"></i>
                        </a>
                        <button [hidden]="!(timelineItem.moderation.status.description === 'Submitted')"
                                class="btn btn-primary"
                                (click)="review(timelineItem)"
                                data-cy="moderation-admin-review"
                                [matTooltip]="'Start reviewing'"><i class="fa fa-play"></i>
                        </button>
                        <button [hidden]="!(timelineItem.moderation.status.description !== 'Submitted')"
                                class="btn btn-primary"
                                (click)="restore(timelineItem)" data-cy="moderation-admin-restore"
                                [matTooltip]="'No harm, restore the comment back'"><i class="fa fa-check"></i>
                        </button>
                        <button [hidden]="!(timelineItem.moderation.status.description !== 'Submitted')"
                                class="btn btn-danger"
                                (click)="moderate(timelineItem)"
                                [matTooltip]="'Moderate, hide from the users'"><i class="fa fa-ban"></i>
                        </button>
                    </div>
                </td>
            </tr>
            }
        </tbody>
    </table>
</div>